import styled from 'styled-components';
import React, { ElementType } from 'react';
import { generateLogzTestAttributes } from '@logz-pkg/test-selectors';
import { Divider } from '../../Divider/Divider.component';

const PlainTableHead = styled.thead`
  background-color: transparent;
`;

const PlainTableRow = styled.tr<{ key?: string | number | null; highlight?: boolean }>`
  border-bottom: transparent;
`;

const PlainTableDataCell = styled.td<{ key?: string | number }>`
  vertical-align: middle;
`;
const DividerTableDataCell = styled.td`
  vertical-align: middle;
  padding: 0 6px;
`;

const PlainTableBody = ({ children, ...props }) => (
  <tbody {...props}>
    <PlainTableRow>
      <DividerTableDataCell colSpan={30}>
        <Divider color={'gray.700'} />
      </DividerTableDataCell>
    </PlainTableRow>
    {children}
  </tbody>
);

interface IPlainTableProps {
  subject?: string;
  children?: React.ReactNode;
}

interface ExtendedTable extends React.FC<IPlainTableProps> {
  Head: ElementType;
  Row: React.ComponentType<{ key?: string | number | null; highlight?: boolean; children?: React.ReactNode }>;
  Cell: React.ComponentType<{ key?: string | number; children?: React.ReactNode }>;
  Divider: ElementType;
  Body: ElementType;
}

const Table: ExtendedTable = ({ subject, ...props }) => (
  <table {...generateLogzTestAttributes({ context: 'plain-table', subject })} width={'100%'} {...props} />
);

Table.Head = PlainTableHead;
Table.Row = PlainTableRow;
Table.Cell = PlainTableDataCell;
Table.Divider = DividerTableDataCell;
Table.Body = PlainTableBody;

export const PlainTable = Table;
